module.exports = __webpack_public_path__ + "studentIcon.png?6e92e75985c8b947313f3ad07a9d052b";